import { PaymentOptionType as PaymentGateway, getPaymentOptions, } from '@debbie/common/dist/collectors/index.js';
import { resolvePaymentPlansConfig } from '@debbie/common/dist/economy/payment-plans/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { LineThrough, PlaceholderLoader } from '../index.js';
import PaymentOption from './PaymentOption/index.js';
const Pay = (props) => {
    const { collector, isPaymentPlan, case: singleCase } = props;
    if (!singleCase) {
        return null;
    }
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const { plans } = resolvePaymentPlansConfig(creditor?.paymentPlansConfig, tenant?.paymentPlansConfig);
    const showPaymentPlans = plans.length > 0;
    const caseVouchers_ = useCaseVouchersByCase(props.case.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const paymentOptions = collector &&
        collector.paymentOptions &&
        singleCase &&
        getPaymentOptions(collector.paymentOptions, singleCase.currency)
            .filter((option) => {
            if ([
                PaymentGateway.REEPAY,
                PaymentGateway.FARPAY,
                PaymentGateway.MOBILE_PEOPLE,
            ].includes(option.type)) {
                return option.isActive;
            }
            return true;
        })
            .filter((p) => !p.hideOnDebtorweb);
    return (React.createElement("div", null,
        React.createElement(PaymentPanel, null,
            React.createElement("h3", { className: "header" }, lang.debtorWebHome.paymentMethods),
            paymentOptions && caseVouchers ? (React.createElement(React.Fragment, null,
                React.createElement("div", null, props.children),
                paymentOptions.map((paymentOption, index) => (React.createElement(React.Fragment, null,
                    index + 1 === paymentOptions.length &&
                        paymentOptions.length > 1 ? (React.createElement(LineThrough, null,
                        React.createElement("span", null, lang.debtorWebHome.or))) : null,
                    React.createElement(PaymentOption, { key: index, paymentOption: paymentOption, case: singleCase, collector: collector, caseVouchers: caseVouchers, isPaymentPlan: isPaymentPlan, paymentOptionsCount: paymentOptions ? paymentOptions.length : 0 })))))) : (React.createElement(PlaceholderLoader, null))),
        !isPaymentPlan &&
            showPaymentPlans &&
            !tenant?.settings?.debtorweb?.doNotEncourageAPaymentPlan && (React.createElement(SubPaymentMethod, { className: "ui-test-3ba49359", to: `/cases/${singleCase.id}/payment-plan` },
            React.createElement("p", null, lang.debtorWebHome.createAPaymentPlan)))));
};
export default Pay;
const SubPaymentMethod = styled(Link) `
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  color: ${THEME.TEXT_MUTED};
  font-weight: 700;
  font-size: 0.9em;
`;
const PaymentPanel = styled.div `
  padding: 0px ${THEME.GRID_SPACING * 3}px ${THEME.GRID_SPACING}px;
  background-color: ${(props) => props.secondary ? THEME.COLOR_PRIMARY : THEME.COLOR_SECONDARY};
  color: ${(props) => props.secondary ? THEME.COLOR_SECONDARY : THEME.COLOR_PRIMARY};
  border-radius: 5px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);

  .providers {
    padding: ${THEME.GRID_SPACING}px 0;
    text-align: center;

    img {
      max-width: 80%;
      max-height: 20px;
    }
  }

  .header {
    border-bottom: 1px solid ${THEME.DARK_COLOR_SECONDARY};
    text-align: center;
    padding: ${THEME.GRID_SPACING}px;
    margin: 1em -${THEME.GRID_SPACING * 3}px;
    text-transform: uppercase;
    font-size: 1.1em;
    background-color: ${THEME.COLOR_SECONDARY};
  }
`;
//# sourceMappingURL=Pay.js.map